export default {
	name: 'DogPurchaseView'
}